// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

import { maxWidth } from '@utils/helpers';

export const PoppingMenu = styled(motion.div)(
    ({ theme: { palette } }) => css`
        background-color: ${palette.neutral.white};
        height: 100vh;
        left: 0;
        overflow-x: hidden;
        overflow-y: auto;
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 999;
    `,
);

export const HeaderBackground = styled.div(
    ({ theme: { palette } }) => css`
        background: ${palette.neutral.white};
        height: 70px;
        position: sticky;
        top: 0;
        width: 100%;
    `,
);

export const MobileNavigation = styled(motion.nav)`
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    padding: 0 16px;
    width: 100%;
`;

export const MobileWrapper = styled(motion.div)`
    align-items: center;
    display: grid;
    grid-template-columns: auto 1fr auto;
    justify-content: space-between;
    width: 100%;
`;

export const BurgerWrapper = styled.div<{ width?: number }>(
    ({ width }) => css`
        width: ${width ? width : 24}px;
        height: 24px;
    `,
);

export const GuestMode = styled.div(
    ({ theme: { palette, radius } }) => css`
        background-color: ${palette.neutral.gray};
        border-radius: ${radius[8]}px;
        padding: 2px 18px;

        ${maxWidth('xxs')} {
            padding: 2px 4px;
        }
    `,
);

export const GuestModeText = styled(Typography.TextBody_12_18)(
    ({ theme: { fontWeight } }) => css`
        font-weight: ${fontWeight.bold};
        text-transform: uppercase;
    `,
);

export const IconButton = styled.button<{ isOpen?: boolean }>(
    ({ isOpen }) => css`
        background-color: transparent;
        border: none;
        cursor: pointer;
        padding: 0;
        position: relative;
        ${isOpen && 'pointer-events: none;'}
    `,
);

export const MenuIcon = styled(IconManager)`
    pointer-events: none;
    width: 24px;
`;

export const NotificationsDot = styled.div`
    ${({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.default};
        border-radius: ${radius[50]}%;
        border: 1px solid ${palette.neutral.white};
        height: 10px;
        pointer-events: none;
        position: absolute;
        right: 0px;
        top: 1px;
        width: 10px;
    `}
`;
